<template>
  <form class="needs-validation ml-0" @submit.prevent="update" novalidate>
    <div class="col px-0 pr-lg-3">
      <section class="bg-white rounded mb-4 p-3 p-sm-4">
        <h1 class="h2 mb-3">Committee Affiliation Details</h1>
        <div role="alert" class="alert alert-warning" v-if="errors">{{ errors }}</div>

        <div class="affiliation-form-wrapper">
          <div class="row block">
            <div class=" col-12 col-md-6 form-group">
              <label for="committeeName">Committee Name</label>
              <input type="text" class="form-control" id="committeeName" :value="affiliation.name" disabled>
            </div>

            <div class="col-12 col-md-6 form-group">
              <label for="committeeEmail">Mailing Address </label>
              <input type="text" class="form-control" :class="{ 'is-invalid': $v.affiliation.mailing_address.$error }"
                     id="committeeEmail" v-model.trim="$v.affiliation.mailing_address.$model">
              <div class="invalid-tooltip">Please include the Mailing Address.</div>
            </div>
          </div>

          <div class="row">
            <div class=" col-12 col-md-6 form-group">
              <label for="committeeSuburb">Suburb </label>
              <input type="text" class="form-control" id="committeeSuburb" :value="affiliation.suburb" disabled>
            </div>

            <div class="col-6 col-md-3 form-group">
              <label>State</label>
              <select class="form-control" :value="affiliation.state" disabled>
                <option disabled></option>
                <option value="QLD">Queensland</option>
                <option value="NSW">New South Wales</option>
                <option value="VIC">Victoria</option>
                <option value="ACT">Australian Capital Territory</option>
                <option value="SA">South Australia</option>
                <option value="NT">Northern Territory</option>
                <option value="WA">Western Australia</option>
                <option value="TAS">Tasmania</option>
              </select>
            </div>

            <div class="col-6 col-md-3 form-group">
              <label for="CommitteePostcode">Postcode </label>
              <input type="text" class="form-control" id="CommitteePostcode" :value="affiliation.post_code" disabled>
            </div>
          </div>
        </div>

        <div class="row block">
          <div class="col-12 col-md-6 form-group">
            <label for="committeeGroundsAddress">Campdraft Grounds Address </label>
            <input type="text" class="form-control" :class="{ 'is-invalid': $v.affiliation.grounds_address.$error }"
                   id="committeeGroundsAddress" v-model.trim="$v.affiliation.grounds_address.$model">
            <div class="invalid-tooltip">Please include the Campdraft Grounds Address.</div>
          </div>

          <div class="col-12 col-md-6 form-group">
            <label for="committeeGroundsAddressSuburb">Suburb </label>
            <input type="text" class="form-control" id="committeeGroundsAddressSuburb"
                   :value="affiliation.grounds_suburb" disabled>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6 form-group">
            <label>State </label>
            <select class="form-control" :value="affiliation.grounds_state" disabled>
              <option disabled></option>
              <option value="QLD">Queensland</option>
              <option value="NSW">New South Wales</option>
              <option value="VIC">Victoria</option>
              <option value="ACT">Australian Capital Territory</option>
              <option value="SA">South Australia</option>
              <option value="NT">Northern Territory</option>
              <option value="WA">Western Australia</option>
              <option value="TAS">Tasmania</option>
            </select>
          </div>

          <div class="col-12 col-md-6 form-group">
            <label>Postcode </label>
            <input type="text" class="form-control" :value="affiliation.grounds_postcode" disabled>
          </div>
        </div>

        <div class="row block">
          <div class="col-12 col-md-6 form-group">
            <label>President Name</label>
            <input type="text" class="form-control" :class="{ 'is-invalid': $v.affiliation.president_name.$error }"
                   v-model.trim="$v.affiliation.president_name.$model">
            <div class="invalid-tooltip">Please include the President Name.</div>
          </div>

          <div class="col-12 col-md-6 form-group">
            <label>Secretary Name</label>
              <input type="text" class="form-control" :class="{ 'is-invalid': $v.affiliation.secretary_name.$error }"
                     v-model.trim="$v.affiliation.secretary_name.$model">
            <div class="invalid-tooltip">Please include the Secretary Name.</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-md-6 form-group">
            <label>Treasurer Name</label>
              <input type="text" class="form-control" :class="{ 'is-invalid': $v.affiliation.treasurer_name.$error }"
                     v-model.trim="$v.affiliation.treasurer_name.$model">
            <div class="invalid-tooltip">Please include the Treasurer Name.</div>
          </div>

          <div class="col-12 col-md-6 form-group">
            <label>Other Name: (Campdraft Steward etc)</label>
              <input type="text" class="form-control" :value="affiliation.other_name" disabled>
          </div>
        </div>

        <div class="row block">
          <div class="col-12 col-md-6 form-group">
            <b style="font-size: 18px;">At your campdraft grounds, does the committee have access to: </b>
          </div>
        </div>

        <div class="row" style="padding-bottom: 20px;">
          <div class="col-4 col-md-3 form-group">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" id="internet_access"
                     :checked="affiliation.internet_access" disabled>
              <label class="custom-control-label access-to" for="internet_access">
                Internet access
              </label>
            </div>
          </div>
          <div class="col-4 col-md-3 form-group">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" id="phone_service"
                     :checked="affiliation.phone_service" disabled>
              <label class="custom-control-label access-to" for="phone_service">
                Phone service
              </label>
            </div>
          </div>
        </div>

        <div v-for="(draft) in drafts">
          <div class="row">
            <div class="col-6 col-md-3 form-group">
              <label>Proposed Campdraft Start Date</label>
              <input type="date" class="form-control form-date" :value="draft.start" disabled>
            </div>
            <div class="col-6 col-md-3 form-group">
              <label>Proposed Campdraft End Date</label>
              <input type="date" class="form-control form-date" :value="draft.end" disabled>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6 form-group">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" id="event_membership_agree"
                     :checked="affiliation.event_membership_agree" disabled>
              <label class="custom-control-label access-to" for="event_membership_agree">
                By checking this box, your committee consents to receiving an invoice for Event Membership Fees
                collected on behalf of ACA, if your committee chooses to accept Casual Members
              </label>
            </div>
          </div>
        </div>

        <h1 class="h2 mb-3 mt-4" style="font-size: 40px;">ACA Property Owner’s/Lessee’s Liability</h1>
        <div class="row">
          <div class="w-25 ml-3 mt-2">
            <a :href="affiliation.file_path" target="_blank" class="btn btn-primary btn-block"  style="color: var(--white);">
              Download Application
            </a>
          </div>
        </div>
      </section>
    </div>
    <desktop-action-bar>
      <button :class="['btn btn-block', processing ? 'btn-primary-dark' : 'btn-primary']" @click="handleSubmit">
        {{ !processing ? 'Save' : '' }}
        <div v-if="processing" class="spinner-border text-light" role="status"><span class="sr-only">Loading...</span>
        </div>
      </button>
    </desktop-action-bar>
  </form>
</template>

<script>
import axios from "axios"
import HANDLESUBMIT from '@/mixins/formValidation.js'
import { required } from "vuelidate/lib/validators"
import Vue from "vue"
import Vuelidate from 'vuelidate'
import DesktopActionBar from '@/components/DesktopActionBar'

Vue.use(Vuelidate)

export default {
  name: "CommitteeAffiliation",
  props: ['committeeDetails'],
  mixins: [HANDLESUBMIT],
  components: {
    DesktopActionBar
  },

  data() {
    return {
      processing: false,
      errors: '',
      affiliation: this.committeeDetails.affiliations[0],
      drafts: JSON.parse(this.committeeDetails.affiliations[0].drafts)
    }
  },
  validations() {
    return {
      affiliation: {
        mailing_address: {
          required
        },
        grounds_address: {
          required
        },
        president_name: {
          required
        },
        secretary_name: {
          required
        },
        treasurer_name: {
          required
        }
      }
    }
  },
  methods: {
    updateCommittee() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.submitStatus = 'ERROR'
        return
      }
      this.processing = true
      this.data = this.affiliation

      this.submitStatus = 'PENDING'

      axios.patch(`${this.$api}/admin/committee/affiliation`, this.data)
        .then((response) => {
          this.processing = false
          // eslint-disable-next-line
          if (response.data.status === 'success') {
            // eslint-disable-next-line
            this.submitStatus = 'SUCCESS'
            this.$router.push({ name: 'Committees', params: { success: 'Committee saved successfully' } })
          } else {
            this.fieldsValidation(response)
            if (response.data.errors.contact_email) {
              // Contact email
              this.success = ''
              this.errorStatus = 'email'
              if (response?.data?.errors?.contact_email[0]) {
                this.errors = response.data.errors.contact_email[0]
              } else {
                this.errors = 'Please include correct email address.'
              }
            }
            if (response.data.status === 'validation_error') {
              if (response.data.errors.contact_email !== undefined) {
                this.errors = 'Committee email must be unique among committee and user emails'
                this.errorFields.contact_email = true
              } else if (response.data.errors.account_number !== undefined) {
                this.errors = 'Committee account number is not valid'
                this.errorFields.account_number = true
              } else if (response.data.errors.routing_number !== undefined) {
                this.errors = 'Committee BSB is not valid'
                this.errorFields.routing_number = true
              } else if (response.data.errors.postal_code !== undefined) {
                this.errors = 'Committee postcode is not valid'
                this.errorFields.postal_code = true
              } else if (response.data.errors.city !== undefined) {
                this.errors = 'Committee city is not valid'
                this.errorFields.city = true
              } else if (response.data.errors.line1 !== undefined) {
                this.errors = 'Committee address file is not valid'
                this.errorFields.line1 = true
              } else if (response.data.errors.phone !== undefined) {
                this.errors = 'Contact Phone is not valid'
                this.errorFields.phone = true
              } else if (response.data.errors.contact_phone !== undefined) {
                this.errors = 'Contact Phone is not valid'
                this.errorFields.contact_phone = true
              } else if (response.data.errors.abn !== undefined) {
                this.errorStatus = 'Committee ABN is not valid'
                this.errorFields.abn = true
              } else if (response.data.errors.name !== undefined) {
                this.errorStatus = response.data.errors.name[0]
                this.errorFields.name = true
              } else {
                this.errors = 'server validation error'
              }
            }
          }
        })
        .catch((error) => {
          this.processing = false
          // eslint-disable-next-line
          console.log(error)
        })
    },
    update(event) {
      event.preventDefault()
      setTimeout(() => {
        if (this.formComplete) {
          this.updateCommittee()
        }
      }, 10)
    }
  }
}
</script>
<style lang="scss" scoped>
.block {
  padding-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/Committees/Profile/components/CommitteeAffiliation.vue